module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-top-backplates.d5e391b7.png";